export default __webpack_public_path__ + "static/banner-bg-e05800d6609f7f14c2e570c0ac4596b8.jpg";